import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseComponent, CustomValidators, FrontendDisplayHtmlType, LocalStorageWrapper, ValidationHandlerService } from 'lib/Vestra.shared';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { AuthenticationService, ChangePasswordModel } from 'src/app/services/api-services';
import { Location } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent extends BaseComponent {
    public type: FrontendDisplayHtmlType = FrontendDisplayHtmlType.ChangePasswordInfo;
    public form: FormGroup;

    public fieldTextType: boolean[] = [false, false, false];
    constructor(private location: Location, private authenticationService: AuthenticationService, private router: Router, protected override validationHandlerService: ValidationHandlerService, protected override modalService: BsModalService, protected override spinnerService: NgxSpinnerService) {
        super(spinnerService, modalService, validationHandlerService);
    }

    public ngOnInit(): void {
        this.form = new FormGroup({
            currentPassword: new FormControl('', [Validators.required]),
            newPassword: new FormControl('', [Validators.required]),
            confirmPassword: new FormControl('', [Validators.required]),
        });

        this.form.addValidators([CustomValidators.matchValidator('newPassword', 'confirmPassword', 'password_does_not_match')]);
    }

    public send = async (): Promise<any> => {
        if (this.validationHandlerService.checkFormValid(this.form)) {
            const resetPass = this.form.getRawValue();
            const model: ChangePasswordModel = {
                currentPassword: resetPass.currentPassword,
                newPassword: resetPass.newPassword,
                confirmPassword: resetPass.confirmPassword,
            };

            return this.handleSpinner(
                firstValueFrom(this.authenticationService.changePassword(model))
                    .then(res => {
                        this.authenticationService.expireRefreshToken();
                        return Promise.resolve(res);
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.validationHandlerService.handleServerError(err, this.form);
                    })
            );
        }
    };

    public toggleFieldTextType(index: number) {
        this.fieldTextType[index] = !this.fieldTextType[index];
    }
}
